/*************************************************/
/* SEARCH                                        */
/*************************************************/

export function search() {
    const suggestionsSelector = '.search-suggestions';
    const searchFormSelector = '.search-form-global';
    var typeTimer;

    const getAndDisplaySearchResults = (query,searchForm) => {
        const endpointUrl = searchForm.getAttribute('action');
        fetch(`${endpointUrl}?altTemplate=searchSuggestions&q=${query}`)
            .then(response => {
                return response.text();
            }).then(data => {
                searchForm.insertAdjacentHTML('beforeend', data);
            }).catch(err => {
                console.log('Something went wrong in search fetch');
                console.error(err);
            });
    };

    const init = () => {
        const searchFormInputs = document.querySelectorAll(`${searchFormSelector} input`);
        if(searchFormInputs) {
            searchFormInputs.forEach(searchFormInput => {
                searchFormInput.addEventListener('keyup', () => {
                    const searchForm = searchFormInput.closest(searchFormSelector);
                    if (searchForm.dataset.showSuggestions === 'False') return;
                    const query = searchFormInput.value;
                    clearTimeout(typeTimer);
                    typeTimer = setTimeout(() => { 
                        getAndDisplaySearchResults(query,searchForm);
                    }, 500);
                });
            });
         
        }

        document.addEventListener('click', e => {
            const clickTarget = e.target;
            let searchResultBox = document.querySelector(suggestionsSelector);
            if (searchResultBox && clickTarget !== searchResultBox && !clickTarget.closest(suggestionsSelector)) {
                searchResultBox.remove();
            }
        });
    };

    init();
}
